import React from "react";
import { Typography } from "antd";
import { EaseModal } from "../../libs/EaseModal";

const TutorialModal = (props) => {
    return (
        <EaseModal
            title={false}
            hideFooter
            width={650}
            visible={props.visible}
            onCancel={props.toggleTutorialModal.bind(this)}
        >
            <Typography.Title level={4} className="mb-4">
                {props.title || 'WIRE Tutorial'}
            </Typography.Title>
            {/* <iframe
                title="WIRE Tutorial"
                width="100%"
                height="315"
                src="https://www.youtube.com/embed?v=w354a0shSMQ"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            /> */}
            <iframe
                width="100%"
                height="315"
                src={props.url}
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            ></iframe>
        </EaseModal>
    );
};
export { TutorialModal };
